import {
  ClipboardCheck, GraduationCap, FileText, FlaskConical,
  Network, ListChecks, BookMarked,
} from "lucide-react";

export const SERVICES = [
  {
    id: "qa-qc",
    title: "QA / QC Services",
    icon: ClipboardCheck,
    desc: "End-to-end quality assurance and control on site — inspection regimes, checklists, hold points and audits that keep construction aligned to spec.",
    span: "lg:col-span-7",
  },
  {
    id: "training",
    title: "Training",
    icon: GraduationCap,
    desc: "Hands-on capability building for site engineers and QC teams on standards, testing and documentation.",
    span: "lg:col-span-5",
  },
  {
    id: "sop",
    title: "SOP & Methodology",
    icon: FileText,
    desc: "Method statements and standard operating procedures tailored to your project and workforce.",
    span: "lg:col-span-5",
  },
  {
    id: "material",
    title: "Material Inspection",
    icon: FlaskConical,
    desc: "Incoming and in-process material inspection — cement, steel, aggregates, concrete — verified against specification.",
    span: "lg:col-span-7",
  },
  {
    id: "nabl",
    title: "NABL Lab Coordination",
    icon: Network,
    desc: "Coordination with accredited third-party NABL labs for reliable, defensible test results.",
    span: "lg:col-span-4",
  },
  {
    id: "boq",
    title: "BOQ Specifications",
    icon: ListChecks,
    desc: "Precise material and workmanship specifications embedded into your Bill of Quantities.",
    span: "lg:col-span-4",
  },
  {
    id: "standards",
    title: "Standards Guidance",
    icon: BookMarked,
    desc: "Interpretation and application of Indian (IS/IRC) and international standards for your works.",
    span: "lg:col-span-4",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Reduce rework at the root",
    body: "Most rework is designed in, not built in. We intervene early — at method, material and specification level — so defects never reach the pour.",
  },
  {
    no: "02",
    title: "Make quality measurable",
    body: "We convert vague expectations into hold points, checklists and acceptance criteria that anyone on site can act on and audit against.",
  },
  {
    no: "03",
    title: "Independent, defensible evidence",
    body: "Through NABL-accredited labs and disciplined documentation, every claim about quality is backed by traceable, third-party proof.",
  },
  {
    no: "04",
    title: "Build capability that stays",
    body: "We train your teams so the standard holds long after we leave — engineering trust into the way you build.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "Qonnect QA restructured our material inspection flow and rework on our tower project dropped noticeably within two months.",
    name: "Rahul Menon",
    role: "Project Director, Skyline Developers",
  },
  {
    quote: "Their SOPs and standards guidance gave our site engineers a clarity we never had before. Audit-ready, always.",
    name: "Priya Nair",
    role: "Head of Projects, Meridian Infra",
  },
  {
    quote: "The NABL lab coordination alone saved us from a costly dispute. Genuinely dependable quality partners.",
    name: "Arjun Deshpande",
    role: "Founder, Cornerstone Builders",
  },
];

export const STATS = [
  { value: "40%", label: "Average rework reduction" },
  { value: "120+", label: "Inspections per month" },
  { value: "15+", label: "NABL lab partners" },
  { value: "100%", label: "Audit-ready documentation" },
];
